import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["eventSegment"]
  static classes = ["highlighted"]

  highlightEvent(event) {
    const eventIdStr = event.params.event?.toString()

    this.eventSegmentTargets.forEach(eventSegment => {
      if(eventSegment.dataset.calendarEventHighlightEventParam === eventIdStr) {
        eventSegment.classList.add('event-hovered')
      } else {
        eventSegment.classList.remove('event-hovered')
      }
    })
  }

  clearEventHighlight(event) {
    this.eventSegmentTargets.forEach(eventSegment => { 
      eventSegment.classList.remove('event-hovered')
    })
  }
}